<template>
  <b-container fluid style="margin-left: 0; width: 100%; border-radius: 30px;">
    <loading :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="fullPage"
             :opacity=".97"
             :before="true">
      <template v-slot:before><h3>Loading ...</h3></template>
    </loading>
    <div class="container-fluid">
      <b-row style="margin: 5px; text-align: center; width: 100%">
        <b-col sm="4">

        </b-col>
        <b-col sm="4">
          <div v-if="displayMetricsOwnerIfAdminOrCertifier" style="text-align: center">
            Current Winery: {{ this.wineryName }}
          </div>
          <p/>
          <div style="text-align: center">
            Checklist Status: IN PROGRESS
          </div>
        </b-col>
        <b-col sm="4">
        </b-col>
      </b-row>
      <b-row align-h="center" no-gutters id="pdfContent">
        <b-col sm="4" class="no-gutters">
          <b-container fluid
                       style=" width:95%; border-radius: 15px;  padding: 10px 5px 0 5px; margin-right:20px; background-color:rgb(248, 248, 248)">
            <survey-progress
              v-if="myGroupId"
              :fetch-url="`survey/progress/${myGroupId}`"
              :active-section-id="activeSectionId"
              style="margin-bottom: 10px"
            />
            <ul v-bind="surveys" class="survey-tabs">

              <li v-for="value in  surveys.items" :key="value.id">
                <VineyardMenuItemV2 :ref=refName(value.id) :section="value.name" :value="value" :key="value.id"
                                    surveyKey="12345678990" :topLevelParent="[value.name]"></VineyardMenuItemV2>
              </li>
            </ul>
            <b-container fluid class="no-gutters"
                         style="text-align: center; margin-top: 5px; margin-left: 0; margin-right: 0; background-color: green;">
              <b-button @click="saveSurvey"
                        style="display: block; background-color: green; width: 100%; margin-left: 0; margin-right: 0">
                SAVE
              </b-button>
            </b-container>
          </b-container>
        </b-col>
        <b-col sm="8" :style="`margin-left:0px; padding-left: 5px; background-color: ${backgroundColor};`">
          <vineyard-survey-page ref="surveyPage" :page-id="pageId" :answers="answers"/>
        </b-col>

      </b-row>
      <b-row no-gutters>
        <b-col sm="4" style="border-radius: 15px;  padding: 10px 0;">
        </b-col>
        <b-col sm="8" class="no-gutters" style=" padding-left: 5px; background-color: lightgray">
          <b-container style="text-align: left">
            <span class="nav-text" @click="previousPage">
              Previous
            </span>
            <span class="nav-text" @click="nextPage">
              Next
            </span>
          </b-container>
        </b-col>
      </b-row>
      <b-row style="padding-top: 10px">
        <b-col sm="4"></b-col>
        <b-col sm="8">
          <b-container fluid style="text-align: center; margin-top: 5px; margin-bottom: 10px">
            <b-button @click="saveSurvey" style="background-color: green; width:65%">
              SAVE
            </b-button>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modal-1" title="Resolve Conflicts" effect="fade/zoom" hide-footer size="xl">
      <div>
        <p class="my-4">Resolving {{ currentResolutionNumber }} of {{
            Object.getOwnPropertyNames(resolutionMap).length - 1
          }} Conflicts</p>
        <div
            v-html="this.getQuestionById(currentResolutionQuestion) ? this.getQuestionById(currentResolutionQuestion).text : ''"></div>
        <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
        <b-form-group label="Responses">
          <b-form-radio v-model="selectedResponse" name="some-radios" :value="theirResponse">Their
            Response: {{ theirResponse }}
          </b-form-radio>
          <b-form-radio v-model="selectedResponse" name="some-radios" :value="myResponse">My Response: {{
              myResponse
            }}
          </b-form-radio>
        </b-form-group>

        <div slot="modal-footer" class="modal-footer">
          <button type="button" class="btn btn-success" @click.prevent="nextAction" :disabled="canNext">
            Next
          </button>
          <button type="button" class="btn btn-success" @click.prevent="saveAction" :disabled="canSave">
            Save
          </button>
          <button type="button" class="btn btn-default" @click.prevent="cancelAction">Cancel</button>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import html2canvas from "html2canvas";
import VineyardMenuItemV2 from "@/components/vineyard/VineyardMenuItemV2";
import VineyardSurveyPage from "@/components/vineyard/VineyardSurveyPage";
import Bus from "@/eventBus";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import {onExport} from "@/exportSpreadsheet";
import SurveyProgress from "@/components/SurveyProgress";

Array.prototype.groupBy = function (prop) {
  return this.reduce(function (groups, item) {
    const val = item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups
  }, {})
}

export default {
  name: "VineyardPage",
  props: {
    thePageId: String,
    groupId: String,
    mySurveyResponseId: String
  },
  components: {
    VineyardSurveyPage,
    VineyardMenuItemV2,
    Loading,
    SurveyProgress
  },
  data() {
    return {
      id: this.mySurveyResponseId,
      surveyKey: "",
      creatorId: "creatorId",
      creationDate: new Date().getTime(),
      lastUpdated: new Date().getTime(),
      certificationPeriodStart: new Date().getTime(),
      certificationPeriodEnd: new Date().getTime(),
      actualCertificationDate: new Date().getTime(),
      status: "",
      version: "",
      lastUpdatedBy: "",
      responsesMap: {},
      myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      surveyType: "INITIAL",
      answers: {},
      surveys: {},
      editMode: true,
      pageId: this.thePageId || '',
      // Data required for conflict resolution.
      currentResolutionQuestion: "",
      currentResolutionNumber: 1,
      theirResponse: '',
      myResponse: '',
      selectedResponse: '',
      isAdmin: localStorage.getItem('roles') !== null && (localStorage.getItem('roles').includes('admin')
          || localStorage.getItem('roles').includes('VINEYARD_ADMIN')),
      isCertifier: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('THIRD_PARTY_CERTIFIER'),
      //checkboxMine: '',
      //checkboxTheirs: '',
      //patchMap: {},
      resolutionMap: {},
      modalSaveDisabled: true,
      nextButtonDisabled: false,
      patchResponseMap: new Map(),
      checklistMeta: {},
      backgroundColor: "#F8F8F8",
      wineryName: '',
      resolutionMeasures: [],
      isLoading: false,
      Datas: {
        'actionPlan': []
      },
    }
  },
/*  beforeRouteLeave(to, from, next) {
    const answer = window.confirm('Do you really want to leave? You may have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },*/
  created() {
    Bus.$on('vineyard-page-update', this.changeVineyardSurveyPage);
    Bus.$on('vineyard-page-background-update', this.updateBackgroundColor);
    Bus.$on('measure-answer-update', this.updateAnswer);
    Bus.$on('create-excel', this.exportXls);
  },
  beforeDestroy() {
    Bus.$off('vineyard-pageUpdate', this.changeVineyardSurveyPage);
    Bus.$off('vineyard-page-background-update', this.updateBackgroundColor);
    Bus.$off('measure-answer-update', this.updateAnswer);
  },
  methods: {
    exportXls: function (workbookName) {
      onExport(workbookName, this.Datas, this.ch)
    },
    saveCheckBoxAsString: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (Array.isArray(value[1])) {
          responseData[value[0]] = JSON.stringify(value[1]);
        }
      })
      return responseData;
    },
    getQuestionById: function (id) {
      let measure = this.resolutionMeasures.find(theMeasure => theMeasure._id === id);
      console.log("Measure Resolution:");
      console.log(measure);
      return measure;
    },
    unwindJsonToCheckBox: function (responseData) {
      Object.entries(responseData).map((value, key) => {
        if (typeof value[1] === "string" && value[1].startsWith("[") && value[1].endsWith("]")) {
          let valueObject = JSON.parse(value[1]);
          console.log("Parsed Value Object");
          console.log(valueObject)
          responseData[value[0]] = valueObject;
        }
      });
      return responseData;
    },
    nextAction: function () {
      if (this.selectedResponse === '') {
        return;
      }
      this.patchResponseMap.set(this.currentResolutionQuestion, this.selectedResponse);

      let currentResolutionQuestionIndex = Object.keys(this.resolutionMap).findIndex((element) => {
        return element === this.currentResolutionQuestion
      });
      this.currentResolutionQuestion = Object.keys(this.resolutionMap)[currentResolutionQuestionIndex + 1];
      ++this.currentResolutionNumber;
      //this.currentResolutionQuestion = Object.keys(this.resolutionMap).find()[++this.currentResolutionNumber];
      this.theirResponse = this.getResponseOrUnanswered(this.resolutionMap[this.currentResolutionQuestion][0]);
      this.myResponse = this.getResponseOrUnanswered(this.resolutionMap[this.currentResolutionQuestion][1]);
      if (Object.getOwnPropertyNames(this.resolutionMap).length === this.currentResolutionNumber) {
        this.modalSaveDisabled = false;
        this.nextButtonDisabled = true;
      }
    },
    cancelAction: function () {
      this.$bvModal.hide("modal-1");
    },
    saveAction: function () {
      this.patchResponseMap.set(this.currentResolutionQuestion, this.selectedResponse);
      let self = this;

      let patchResponseList = {};
      this.patchResponseMap.forEach((value, key) => {
        patchResponseList[key] = value;
      });

      let surveyResponse = {
        _id: self.id,
        surveyKey: self.surveyKey,
        responsesMap: self.patchResponseMap,
        lastUpdated: self.lastUpdated,
        lastUpdatedBy: localStorage.getItem('user'),
        patchResponseMap: patchResponseList,
        groupId: self.myGroupId
      };
      this.$http.patch("survey", surveyResponse, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(returnVal => {
            if (returnVal.data.saved === true) {
              this.$toasted.info("Checklist Resolved Successfully", {
                containerClass: 'super-toasty',
                iconPack: 'fontawesome',
                closeOnSwipe: true,
                className: 'mighty-toasty',
                action: {
                  text: 'DISMISS',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                },
                icon: {
                  name: 'fa-save',
                  after: false
                }
              })
                  .goAway(5000);
              let url = this.buildSurveyResponseUrl();
              // This should happen first
              this.loadSurveyResponse(url);
              this.patchResponseMap = new Map();
              this.currentResolutionQuestion = '';
              this.currentResolutionNumber = 1;
            } else {
              Swal.fire({
                title: 'Survey Save Failed',
                text: 'There was an error while saving.',
                icon: 'error'
              });
              ø
            }

          }).catch(error => {
        Swal.fire({
          title: 'Survey Save Failed',
          text: `There was an error while saving. Error: ${error.message}`,
          icon: 'error'
        });
      });
      this.$bvModal.hide("modal-1");
    },
    toSurveyResponse: function () {
      let responseObject = this.saveCheckBoxAsString(this.answers);
      let certificationPeriodStart = this.certificationPeriodStart;
      let response = {
        _id: this.id,
        surveyKey: this.surveyKey,
        creatorId: this.creatorId,
        creationDate: this.creationDate,
        lastUpdated: this.lastUpdated,
        certificationPeriodStart: certificationPeriodStart,
        certificationPeriodEnd: this.certificationPeriodEnd,
        actualCertificationDate: this.actualCertificationDate,
        status: "IN_PROGRESS", //this.status,
        version: this.version,
        lastUpdatedBy: localStorage.getItem("user"),
        responsesMap: responseObject,
        groupId: this.myGroupId,
        surveyType: this.surveyType
      };
      return response;
    },
    changeVineyardSurveyPage: function (newPageId) {
      this.pageId = newPageId;
    },
    updateAnswer: function (questionId, value) {
      this.answers[questionId] = value;
    },
    refName: function (name) {
      return 'poo' + name;
    },
    doPdf: function () {
      let pdfMake = require("pdfmake/build/pdfmake");
      html2canvas(document.getElementById("pdfQuestions"))
          .then(function (canvas) {
            let html = canvas.toDataURL();
            let content = {content: [{image: html, width: 500}]};
            console.log(content);
            pdfMake.createPdf(content).download('sample.pdf');
          });
    },
    getResponseOrUnanswered: function (response) {
      return (response === '' || response === null) ? "Unanswered" : response;
    },
    saveSurvey: function () {
      console.log("About to save survey");
      let self = this;
      let response = this.toSurveyResponse();
      let surveyJson = JSON.stringify(response, null, 3);
      this.$http.post(`vineyard`, surveyJson, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 202) {
              if (result.data.saved) {
                self.lastUpdated = result.data.lastUpdated;
                this.$store.commit('survey/lastSaved', Date.now());
                this.$toasted.info("Checklist Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  className: 'mighty-toasty',
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {
                self.resolutionMeasures = result.data.differenceMeasures;
                self.resolutionMap = result.data.differenceMap;
                self.currentResolutionQuestion = Object.keys(self.resolutionMap)[0];
                self.theirResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][0]);
                self.myResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][1]);
                self.currentResolutionNumber = 1;
                this.$bvModal.show("modal-1");
              }
            }
          }).catch(
          error => {
            console.log(error)
          });
    },
    nextPage: function () {
      console.log("Next Page");
      let pages = this.checklistMeta.pages;
      let currentPageIndex = pages.indexOf(this.pageId);
      console.log("Current Index: " + currentPageIndex + " Size of Array: " + pages.length);
      if (currentPageIndex < (pages.length - 1)) {
        this.pageId = pages[currentPageIndex + 1];
        Bus.$emit("page-change", this.pageId);
      }
      this.scrollToTop();
    },
    previousPage: function () {
      console.log("Previous Page");
      let pages = this.checklistMeta.pages;
      let currentPageIndex = pages.indexOf(this.pageId);
      console.log("Current Index: " + currentPageIndex + " Size of Array: " + pages.length);
      if (currentPageIndex > 0) {
        this.pageId = pages[currentPageIndex - 1];
        Bus.$emit('page-change', this.pageId);
      }
      this.scrollToTop();
    },
    scrollToTop() {
      window.scrollTo(0, 0);

    },
    updateBackgroundColor: function (color) {
      console.log(`Background Color:${color} Updated `);
      this.backgroundColor = color;
    },
    getGroupInfo: function () {
      this.$http.get("/groups/name/" + this.myGroupId, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(response => {
        this.wineryName = response.data.name;
      }).catch(error => {
        console.log("Error getting Data: " + error);
      });
    },
    loadSurveyResponse: function (url) {
      let self = this;
      return this.$http.get(url)
          .then(result => {
            this.surveyData = result.data;
            self.id = result.data._id;
            self.lastUpdated = result.data.lastUpdated;
            self.responsesMap = self.unwindJsonToCheckBox(result.data.responsesMap);
            self.answers = self.unwindJsonToCheckBox(result.data.responsesMap);
            self.certificationPeriodStart = self.surveyData.certificationPeriodStart;
            self.certificationPeriodEnd = self.surveyData.certificationPeriodEnd;
            self.surveyKey = result.data.surveyKey;
            self.creationDate = self.surveyData.creationDate;
            self.creatorId = self.surveyData.creatorId;
            self.status = self.surveyData.status;
            self.surveyType = self.surveyData.surveyType;
            self.lastUpdatedBy = self.surveyData.lastUpdatedBy;
            self.actualCertificationDate = self.surveyData.actualCertificationDate;
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              title: 'Error Loading Survey',
              text: `Could not load survey with error: ${err.message}`,
              icon: 'error'
            });
          })
    },
    buildSurveyResponseUrl: function () {
      let url;
      let self = this;
      if (self.isAdmin || self.isCertifier) {
        if (!self.id) {
          Swal.fire({
            title: 'Select A Survey',
            text: 'Please Select a Winery to Continue.',
            icon: 'question'
          });
          this.$router.push("/questionnaire-admin");
          return;
        }
        url = "vineyard/response/id/" + self.id;
      } else {
        url = "vineyard/response/" + self.myGroupId;
        //let groupId = localStorage.getItem('groupId');
        //url = "vineyard/response/" + self.groupId;
      }
      return url;
    }
  },
  computed: {
    canEdit: function () {
      return this.editMode;
    },
    activeSectionId() {
      return this.$store.state.survey.activeSectionId || ''
    },
    canSave() {
      return this.modalSaveDisabled && this.selectedResponse === '';
    },
    canNext() {
      return (Object.getOwnPropertyNames(this.resolutionMap).length - 1) === this.currentResolutionNumber;
    },
    displayMetricsOwnerIfAdminOrCertifier: function () {
      return this.isAdmin || this.isCertifier;
    }
  },
  mounted() {
    let self = this;
    self.isLoading = true;
    this.$http.get(`vineyard/${this.myGroupId}/menu`)
        .then(result => {
          self.surveys = result.data;
        })
        .then(() => {
          console.log("The Mounted: " + self.pageId);
          Bus.$emit("page-change", self.pageId);
        })
        .catch(
            error => {
              console.log(error)
            });

    let url = this.buildSurveyResponseUrl();
    if (!url) {
      return;
    }
    // This should happen first
    this.loadSurveyResponse(url);
    // Menu Pull This will need to change to get the active menu
    this.$http.get(`vineyard/survey/checklist/${this.myGroupId}`)
        .then(result => {
          self.checklistMeta = result.data;
          self.surveyKey = result.data._id
          if (!self.pageId) {
            self.pageId = self.checklistMeta.pages[0]
          }
          self.isLoading = false;
        }).catch(
        error => {
          console.log(error)
        });

    this.getGroupInfo();
  }
}


</script>
<style>

.nav-text {
  font-size: 20px;
  margin: 10px;
  color: black;
  cursor: pointer;
}

.mighty-toasty {
  background-color: #1e7e34 !important;
}

.survey-tabs {
  font-weight: 600;
  font-size: 14pt;
  font-family: "'Montserrat, sans-serif", serif;
  list-style-type: none;
  padding-left: 0;
}
</style>

